export default {
  'financial.billsToPay.form.situation': 'Situação',
  'financial.billsToPay.form.situation.open': 'Abertos',
  'financial.billsToPay.form.situation.liquidated': 'Liquidados',
  'financial.billsToPay.form.filterByDate': 'Filtrar por Data de',
  'financial.billsToPay.form.filterByDate.maturity': 'Vencimento',
  'financial.billsToPay.form.filterByDate.payment': 'Pagamento',
  'financial.billsToPay.form.filterByDate.issuance': 'Emissão',
  'financial.billsToPay.form.display': 'Exibir',
  'financial.billsToPay.form.display.payReceive': 'Contas a pagar/receber',
  'financial.billsToPay.form.display.tariffs': 'Tarifas',
  'financial.billsToPay.form.display.showRefund': 'Incluir estornos',
  'financial.billsToPay.form.display.singleEntries': 'Lançamentos avulsos',
  'financial.billsToPay.form.moreOptions': 'Mais Opções',
  'financial.billsToPay.form.filterExpensesBy': 'Filtrar Despesas por',
  'financial.billsToPay.form.filterExpensesBy.none': 'Nenhuma',
  'financial.billsToPay.form.filterExpensesBy.fixedExpenses': 'Despesas Fixas',
  'financial.billsToPay.form.filterExpensesBy.variableExpenses':
    'Despesas Variáveis',
  'financial.billsToPay.form.filterExpensesBy.withoutClassification':
    'Sem Classificação',
  'financial.billsToPay.form.chartOfAccounts': 'Plano de Contas',
};
